import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';
import bank from './bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';
import { CopyToClipboard } from "react-copy-to-clipboard/src";
import { Copy } from 'lucide-react';

import { changeNum, convertDateFormat } from './common/function';

const 불가카드옵션 = [
    "BC카드", "KB국민카드", "NH농협카드", "광주은행", "롯데카드",
    "삼성카드", "수협은행", "신한카드", "씨티카드", "우리카드",
    "전북은행", "제주은행", "지드림카드", "하나카드", "현대카드"
];

function CreateMerchants() {
    let dispatch = useDispatch();
    let navigate = useNavigate();

    let MyData = useSelector((state) => state.MyData);

    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);
    const [loading, setLoading] = useState(true);
    const [createModal, setCreateModal] = useState(false)

    const [message, setMessage] = useState("");
    const [listData, setListData] = useState([]);
    const [combineData, setCombineData] = useState([]);
    const [combineList, setCombineList] = useState([]);
    const [clickData, setClickData] = useState([]);
    const [reload, setReload] = useState(false);
    const [level, setLevel] = useState(3);

    // 큰 이미지 미리보기 모달용
    const [previewImage, setPreviewImage] = useState(null);

    const [listState, setListState] = useState(false);

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on('selected', (start, end) => {
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [nextDate, setNextDate] = useState(dayjs().format('YYYY-MM-DD'));

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'));
    }, []);

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch();
    };

    const onSubmitSearch = () => {
        setPage(1);
        setReload(e => !e);
    };

    // 검색구분
    const select4 = ["가맹점명", "가맹점아이디"];
    const [selectedValue3, setSelectedValue3] = useState("가맹점명");
    const [selectedText3, setSelectText3] = useState("");

    const handleSelectChange3 = (event) => {
        setSelectedValue3(event.target.value);
    };

    const handleSelectTextChange3 = (event) => {
        setSelectText3(event.target.value);
    };

    // 검색 버튼
    const submit = () => {
        setReload(e => !e);
    };

    useEffect(() => {
        dispatch(change_Current_Location("가맹점 등록"));
        dispatch(changeHeaderTitle({
            mainTitle: "가맹점 등록"
        }));

        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    useEffect(() => {
        setPage(1);
        ListData();
    }, [reload]);

    // --------------------------------------------------------------------------------
    // 1) 실제 API 대신, 목업 데이터로 ListData를 구성하는 예시
    // --------------------------------------------------------------------------------
    const ListData = async () => {
        // 실제 API 사용 시 주석 해제
        await axios
            .get(process.env.REACT_APP_API + "/api/merchant-temp", {
                withCredentials: true,
                params: {}
            })
            .then((response) => {
                let tmp = response?.data;
                if (tmp?.code < 2000) {
                    setListData(tmp?.data?.list ?? []);
                    setListState(e => !e);
                    setLevel(tmp?.data?.agent?.level ?? 3);
                } else if (tmp?.code === 9999) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.error(error);
                navigate("/");
            });
    };

    // --------------------------------------------------------------------------------
    // 2) 테이블 헤더: 날짜, 가맹점명, 에이전트명, 상태
    // --------------------------------------------------------------------------------
    const tableHeaderData = [
        { no: 1, text: "날짜", width: "100px", textAlign: "center" },
        { no: 3, text: "에이전트명", width: "130px", textAlign: "center" },
        { no: 2, text: "가맹점명", width: "130px", textAlign: "center" },
        { no: 4, text: "상태", width: "70px", textAlign: "center" },
    ];

    // --------------------------------------------------------------------------------
    // 3) 테이블 바디: 상태가 "대기"이면 버튼, "승인완료"이면 텍스트
    // --------------------------------------------------------------------------------
    useEffect(() => {
        let tableBodyData = [];
        if (listData.length > 0) {
            setCombineList(listData);

            for (let i = 0; i < listData.length; i++) {
                let data = listData[i];

                // 날짜 포맷 변경 (예: "2023-07-06 14:24:56" → "23-07-06 14:24")
                const dateStr = dayjs(data.updated_at).format("YY-MM-DD HH:mm");

                // 상태 표시를 분기
                let statusCell;
                if (data.status === "W") {
                    // 대기는 버튼 표시
                    statusCell = statusCell = <div style={{ textAlign: "center" }}>확인</div>;
                } else if (data.status === "P") {
                    // 승인완료는 텍스트만
                    statusCell = <div style={{ textAlign: "center" }}>URL발송</div>;
                } else {
                    // 혹시 다른 상태가 있을 경우 대비
                    statusCell = <div style={{ textAlign: "center" }}>추가인증요청</div>;
                }

                let rowData = [
                    {
                        no: 1,
                        text: dateStr,
                        width: "100px",
                        textAlign: "center",
                    },
                    {
                        no: 3,
                        text: data.salesman_nm,
                        width: "130px",
                        textAlign: "left",
                    },
                    {
                        no: 2,
                        text: data.business_name,
                        width: "130px",
                        textAlign: "left",
                    },
                    {
                        no: 4,
                        text: statusCell,
                        width: "70px",
                        textAlign: "center",
                    },
                ];

                rowData.id = data.id; // 클릭 시 식별
                tableBodyData.push(rowData);
            }
            setCombineData(tableBodyData);
            setListState((e) => !e);
        }
    }, [listData, page, maxFirstPage, reload]);

    const handleRowClick = (row) => {
        const found = combineList.find((d) => d.id === row.id);
        if (found) {
            setClickData(found);
            setCreateModal(true)
        }
    };

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : null}

            {/* 큰 이미지 미리보기 모달 */}
            {previewImage && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0,0,0,0.7)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 9999,
                    }}
                    onClick={() => setPreviewImage(null)}
                >
                    <img
                        src={previewImage}
                        alt="preview-large"
                        style={{
                            maxWidth: "90%",
                            maxHeight: "90%",
                            border: "2px solid #fff",
                            objectFit: "contain",
                        }}
                    />
                </div>
            )}
            <MessageModal message={message} />

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                    <SearchSelectText
                        type={"검색구분"}
                        selectData={select4}
                        handleSelectChange={handleSelectChange3}
                        selectedValue={selectedValue3}
                        handleSelectTextChange={handleSelectTextChange3}
                        selectedText={selectedText3}
                        btnText={"검색"}
                        onClick={() => submit()}
                    />
                </form>
            </div>
            <div className="intro-y box intro-padding">
                <div className="div-flex-2">
                    <div style={{ maxWidth: "450px", width: "100%" }}>
                        <div
                            className="tabulator_sorting_wrap"
                            style={{
                                flexDirection: "row",
                                marginBottom: "8px",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <CountAmountLeft tableBodyData={combineList ?? []} />
                            <div className="button_wrap separate" style={{ marginTop: "0px", marginRight: "1px" }}>
                                <SearchCrteateBtn
                                    type={"신규 등록"}
                                    onClick={() => {
                                        setClickData(null);
                                        setCreateModal(true)
                                    }}
                                />
                            </div>
                        </div>
                        <List
                            tableHeaderData={tableHeaderData}
                            tableBodyData={combineList ?? []}
                            filter_tableBodyData={combineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            clickData={clickData}
                            onRowClick={handleRowClick}
                            listType={true}
                            listState={listState}
                        />
                    </div>

                    {
                        !createModal  && (
                            <div className='mt-3 div-flex-2-1' style={{ border: "10px solid #575757", height: "818px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "18px", fontWeight: "bold", color: "gray", marginTop: "49px" }}>
                                가맹점을 선택해주세요
                            </div>
                        )
                    }
                    {createModal && MyData?.role == "SUPER" && (
                        <div
                            className="mt-3 div-flex-2-1"
                            style={{ backgroundColor: "#575757", padding: "10px", marginTop: "49px", height: "818px" }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "0 10px",
                                    borderBottom: "1px solid #E5E5E5",
                                    backgroundColor: "#fff",
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                    {["가맹점 등록"].map((tab) => (
                                        <button
                                            key={tab}
                                            className={`tab-btn active`}
                                            style={{
                                                padding: "12px 10px 8px",
                                                fontSize: "14px",
                                                fontWeight: "600",
                                                color: "#222",
                                                background: "transparent",
                                                border: "none",
                                                borderBottom: "3px solid #3182F6",
                                                transition: "all 0.2s ease-in-out",
                                                cursor: "pointer",
                                            }}
                                        >
                                            {tab}
                                        </button>
                                    ))}
                                </div>
                            </div>

                            <div style={{ padding: "0 10px", backgroundColor: "#fff" }}>
                                <CreateInfo setMessage={setMessage} clickData={clickData} setReload={setReload} setPreviewImage={setPreviewImage} />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

function CreateInfo({ setMessage, clickData, setReload, setPreviewImage }) {
    const [levelData, setLevelData] = useState([]);
    const [showBannedCards, setShowBannedCards] = useState(false);

    const parsePaymentMethod = (str) => {
        if (!str) return [];
        return str.split(",").map((s) => s.trim());
    };
    const parseSettlementCycle = (str) => {
        if (!str) return [];
        return str.split(",").map((s) => s.trim());
    };

    const initialFormData = {
        사업자구분: clickData?.business_type ?? "비사업자",
        사업자명: clickData?.business_name ?? "",
        사업자등록번호: clickData?.business_registry_no ?? "",
        주민등록번호: clickData?.personal_id_no ?? "",
        대표자명: clickData?.owner_name ?? "",
        업종: clickData?.industry ?? "",
        취급품목: clickData?.product ?? "",
        대표자연락처: clickData?.owner_phone ?? "",
        사업자이메일: clickData?.business_email ?? "",
        담당자명: clickData?.manager_name ?? "",
        담당자연락처: clickData?.manager_phone ?? "",
        사업장주소: clickData?.business_address ?? "",
        단말기수령주소: clickData?.device_delivery_address ?? "",
        서비스: clickData?.service ?? "결제단말기 & 수기결제 어플 수납대행 서비스",
        수수료: clickData?.comm_fee ?? "",
        결제방식: parsePaymentMethod(clickData?.payment_method ?? ""),
        단말기공급조건: clickData?.device_supply_cond ?? "",
        통신비: clickData?.fee ?? "",
        약정기간: clickData?.contract_period_months ?? "",
        "1회한도": clickData?.single_txn_limit ?? "",
        단말기대금: clickData?.device_price ?? "",
        정산은행: clickData?.settle_bank ?? "",
        예금주: clickData?.account_holder ?? "",
        계좌번호: clickData?.account_number ?? "",
        MID: clickData?.mid ?? "",
        수기노출: clickData?.manual_exposure ?? "N",
        영업자: clickData?.salesman_code ?? "",
        계약서URL: clickData?.contract_url ?? "",
        지사: "",
        지사수수료: "",
        총판: "",
        총판수수료: "",
        대리점: "",
        대리점수수료: "",
        일한도: clickData?.daily_limit ?? "",
        월한도: clickData?.monthly_limit ?? "",
        불가카드: clickData?.banned_cards ?? [],
        정산주기: parseSettlementCycle(clickData?.settlement_cycle ?? ""),
        사업자등록증: [],
        통장사본: [],
        신분증앞면: [],
        신분증뒷면: [],
        사업장사진: [],
    };

    const [formData, setFormData] = useState(initialFormData);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // (D) 불가카드 체크박스 높이 측정 ref
    const refCheckboxHeight = useRef(null);
    const [checkboxHeight, setCheckboxHeight] = useState(34);

    // ─────────────────────────────────────────────────────────
    // (E) 마운트/업데이트 로직
    // ─────────────────────────────────────────────────────────
    useEffect(() => {
        LevelList();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            if (refCheckboxHeight.current) {
                setCheckboxHeight(refCheckboxHeight.current.offsetHeight);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (refCheckboxHeight.current && showBannedCards) {
            setCheckboxHeight(refCheckboxHeight.current.offsetHeight);
        }
        else {
            setCheckboxHeight(34);
        }
    }, [showBannedCards, refCheckboxHeight]);

    useEffect(() => {
        const newObj = {
            ...initialFormData,
            결제방식: parsePaymentMethod(clickData?.payment_method ?? ""),
            정산주기: parseSettlementCycle(clickData?.settlement_cycle ?? ""),
            불가카드: clickData?.banned_cards ?? [],
        };
        setFormData(newObj);
    }, [clickData]);

    useEffect(() => {
        if (formData.영업자) {
            agentUpdateList(formData.영업자);
        } else {
            setFormData((prev) => ({
                ...prev,
                지사: "",
                지사수수료: "",
                총판: "",
                총판수수료: "",
                대리점: "",
                대리점수수료: "",
            }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData.영업자]);

    // 상위리스트(영업자) 불러오기
    async function LevelList() {
        try {
            const response = await axios.get(process.env.REACT_APP_API + `/api/merchant/agent-list`, {
                withCredentials: true,
            });
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                setLevelData((tmp?.data?.agent ?? []).sort((a, b) => a.auth_cd - b.auth_cd));
            } else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "상위리스트 조회 중 오류가 발생했습니다." });
        }
    }

    async function agentUpdateList(agent) {
        if (!agent) return;
        try {
            const response = await axios.get(process.env.REACT_APP_API + `/api/merchant/up-list`, {
                params: { code: agent },
                withCredentials: true,
            });
            const tmp = response?.data;
            if (tmp?.code < 2000) {
                let listArr = tmp?.data?.agent;
                setFormData((prev) => ({
                    ...prev,
                    지사: listArr[0]?.agent_name || "",
                    지사수수료: listArr[0] ? Number(listArr[0].agent_fee) : "",
                    총판: listArr[1]?.agent_name || "",
                    총판수수료: listArr[1] ? Number(listArr[1].agent_fee) : "",
                    대리점: listArr[2]?.agent_name || "",
                    대리점수수료: listArr[2] ? Number(listArr[2].agent_fee) : "",
                }));
            } else {
                setMessage({ msg: "상위리스트 업로드에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
        }
    }

    // ─────────────────────────────────────────────────────────
    // (F) 폼 입력 변경
    // ─────────────────────────────────────────────────────────
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        // (1) 불가카드 배열
        if (name === "불가카드" && type === "checkbox") {
            setFormData((prev) => {
                const oldArr = prev.불가카드 || [];
                if (checked) {
                    return { ...prev, 불가카드: [...oldArr, value] };
                } else {
                    return { ...prev, 불가카드: oldArr.filter((c) => c !== value) };
                }
            });
            return;
        }

        // (2) 결제방식 (단말기, 수기) checkbox
        if (name === "결제방식" && type === "checkbox") {
            setFormData((prev) => {
                const oldArr = prev.결제방식 || [];
                if (checked) {
                    return { ...prev, 결제방식: [...oldArr, value] };
                } else {
                    return { ...prev, 결제방식: oldArr.filter((m) => m !== value) };
                }
            });
            return;
        }

        // (3) 정산주기 (익일, 당일) checkbox
        if (name === "정산주기" && type === "checkbox") {
            setFormData((prev) => {
                const oldArr = prev.정산주기 || [];
                if (checked) {
                    return { ...prev, 정산주기: [...oldArr, value] };
                } else {
                    return { ...prev, 정산주기: oldArr.filter((m) => m !== value) };
                }
            });
            return;
        }

        // (4) 일반
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // ─────────────────────────────────────────────────────────
    // (G) 등록 (서버 전송)
    // ─────────────────────────────────────────────────────────
    const onSubmit = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const fd = new FormData();

            /* =========================================
               [1] 아래는 새로 추가되는 JSON 구조 대응 코드
               ========================================= */
            fd.append("id", clickData?.id ?? "");
            fd.append("business_type", formData.사업자구분);
            fd.append("business_name", formData.사업자명);
            fd.append("business_registry_no", formData.사업자등록번호);
            fd.append("personal_id_no", formData.주민등록번호);
            fd.append("owner_name", formData.대표자명);
            fd.append("industry", formData.업종);
            fd.append("product", formData.취급품목);
            fd.append("owner_phone", formData.대표자연락처);
            fd.append("business_email", formData.사업자이메일);
            fd.append("manager_name", formData.담당자명);
            fd.append("manager_phone", formData.담당자연락처);
            fd.append("business_address", formData.사업장주소);
            fd.append("device_delivery_address", formData.단말기수령주소);
            fd.append("service", formData.서비스);
            fd.append("payment_method", formData.결제방식.join(","));
            fd.append("device_supply_cond", formData.단말기공급조건);
            fd.append("comm_fee", Number(formData.수수료) || 0);
            fd.append("contract_period_months", Number(formData.약정기간) || 0);
            fd.append("single_txn_limit", Number(formData["1회한도"]) || 0);
            fd.append("device_price", Number(formData.단말기대금) || 0);
            fd.append("settle_bank", formData.정산은행);
            fd.append("account_holder", formData.예금주);
            fd.append("account_number", formData.계좌번호);
            fd.append("manual_exposure", formData.수기노출);
            fd.append("contract_url", formData.계약서URL);
            fd.append("daily_limit", Number(formData.일한도) || 0);
            fd.append("monthly_limit", Number(formData.월한도) || 0);
            fd.append("banned_cards", formData.불가카드.join(","));

            /* =========================================
               [2] 기존에 있던 fd.append들 (삭제/생략 X)
               ========================================= */
            // 문자열 필드들
            fd.append("biz_type", formData.사업자구분);
            fd.append("co_nm", formData.사업자명);
            fd.append("co_no", formData.사업자등록번호);
            fd.append("block_card", formData.불가카드.join(","));
            // 결제방식, 정산주기
            fd.append("payment_method", formData.결제방식.join(",")); // 예: "단말기,수기"
            fd.append("settlement_cycle", formData.정산주기.join(",")); // 예: "익일,당일"

            // 파일 업로드
            formData.사업자등록증.forEach((item) => fd.append("business_license", item.file));
            formData.통장사본.forEach((item) => fd.append("bank_account", item.file));
            formData.신분증앞면.forEach((item) => fd.append("id_card_front", item.file));
            formData.신분증뒷면.forEach((item) => fd.append("id_card_back", item.file));
            formData.사업장사진.forEach((item) => fd.append("business_photo", item.file));

            // axios 전송
            const response = await axios.post(process.env.REACT_APP_API + "/api/merchant-temp/approve", fd, {
                withCredentials: true,
            });
            const tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setMessage({ msg: "가맹점 등록에 성공했습니다." });
                setReload((prev) => !prev);
                setFormData(initialFormData);
            } else {
                setMessage({ msg: tmp?.msg ?? "가맹점 등록에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "가맹점 등록 중 오류가 발생했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    const onSubmitURL = async () => {
        if (isSubmitting) return;
        setIsSubmitting(true);

        try {
            const fd = new FormData();

            /* =========================================
               [1] 아래는 새로 추가되는 JSON 구조 대응 코드
               ========================================= */
            fd.append("id", clickData.id);
            fd.append("business_type", formData.사업자구분);
            fd.append("business_name", formData.사업자명);
            fd.append("business_registry_no", formData.사업자등록번호);
            fd.append("personal_id_no", formData.주민등록번호);
            fd.append("owner_name", formData.대표자명);
            fd.append("industry", formData.업종);
            fd.append("product", formData.취급품목);
            fd.append("owner_phone", formData.대표자연락처);
            fd.append("business_email", formData.사업자이메일);
            fd.append("manager_name", formData.담당자명);
            fd.append("manager_phone", formData.담당자연락처);
            fd.append("business_address", formData.사업장주소);
            fd.append("device_delivery_address", formData.단말기수령주소);
            fd.append("service", formData.서비스);
            fd.append("device_supply_cond", formData.단말기공급조건);
            fd.append("comm_fee", Number(formData.수수료) || 0);
            fd.append("contract_period_months", Number(formData.약정기간) || 0);
            fd.append("single_txn_limit", Number(formData["1회한도"]) || 0);
            fd.append("device_price", Number(formData.단말기대금) || 0);
            fd.append("settle_bank", formData.정산은행);
            fd.append("account_holder", formData.예금주);
            fd.append("account_number", formData.계좌번호);
            fd.append("manual_exposure", formData.수기노출);
            fd.append("contract_url", formData.계약서URL);
            fd.append("daily_limit", Number(formData.일한도) || 0);
            fd.append("monthly_limit", Number(formData.월한도) || 0);
            fd.append("banned_cards", formData.불가카드.join(","));

            /* =========================================
               [2] 기존에 있던 fd.append들 (삭제/생략 X)
               ========================================= */
            // 문자열 필드들
            fd.append("biz_type", formData.사업자구분);
            fd.append("co_nm", formData.사업자명);
            fd.append("co_no", formData.사업자등록번호);
            fd.append("block_card", formData.불가카드.join(","));
            // 결제방식, 정산주기
            fd.append("payment_method", formData.결제방식.join(","));
            fd.append("settlement_cycle", formData.정산주기.join(","));

            // 파일 업로드
            formData.사업자등록증.forEach((item) => fd.append("business_license", item.file));
            formData.통장사본.forEach((item) => fd.append("bank_account", item.file));
            formData.신분증앞면.forEach((item) => fd.append("id_card_front", item.file));
            formData.신분증뒷면.forEach((item) => fd.append("id_card_back", item.file));
            formData.사업장사진.forEach((item) => fd.append("business_photo", item.file));

            // axios 전송
            const response = await axios.post(process.env.REACT_APP_API + "/api/merchant-temp/update", fd, {
                withCredentials: true,
            });
            const tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setMessage({ msg: "가맹점 등록에 성공했습니다." });
                setReload((prev) => !prev);
                setFormData(initialFormData);
            } else {
                setMessage({ msg: tmp?.msg ?? "가맹점 등록에 실패했습니다." });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "가맹점 등록 중 오류가 발생했습니다." });
        } finally {
            setIsSubmitting(false);
        }
    };

    // (H) 취소
    const handleCancel = () => {
        setFormData(initialFormData);
    };

    return (
        <>
            <div style={{ padding: "5px" }}>
                <div className="modal-dialog">
                    <div className="marginTop30 modal_sty">
                        <div
                            style={{
                                padding: "0 0 0.5rem",
                                height: "680px",
                                overflowY: "auto",
                                fontSize: "12px",
                                display: "flex",
                                gap: "20px",
                            }}
                        >
                            <div className="list-info-box" style={{ width: "100%" }}>
                                <div className="box-gap">
                                    <div className="gap">
                                        <div
                                            className="modal-header"
                                            style={{ padding: "0.5rem 0" }}
                                        >
                                            <h2 className="font-medium text-base mr-auto modal_title_sty">
                                                사업자 정보
                                            </h2>
                                        </div>
                                        <ul>
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        사업자구분
                                                    </span>
                                                    <select
                                                        name="사업자구분"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.사업자구분}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="비사업자">비사업자</option>
                                                        <option value="사업자">사업자</option>
                                                    </select>
                                                </div>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        {formData.사업자구분 === "사업자" ? "사업자명" : "상호명"}
                                                    </span>
                                                    <input
                                                        name="사업자명"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.사업자명}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                {
                                                    formData.사업자구분 === "사업자"
                                                        ?
                                                        <div className="inner">
                                                            <span
                                                                className="left-text"
                                                                style={{ width: "120px", height: "34px" }}
                                                            >
                                                                사업자등록번호
                                                            </span>
                                                            <input
                                                                name="사업자등록번호"
                                                                type="text"
                                                                className="right-text"
                                                                style={{
                                                                    width: "calc(100% - 122px)",
                                                                    border: "none",
                                                                    outline: "none",
                                                                }}
                                                                value={formData.사업자등록번호}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        :
                                                        <div className="inner">
                                                            <span
                                                                className="left-text"
                                                                style={{ width: "120px", height: "34px" }}
                                                            >
                                                                주민등록번호
                                                            </span>
                                                            <input
                                                                name="주민등록번호"
                                                                type="text"
                                                                className="right-text"
                                                                style={{
                                                                    width: "calc(100% - 122px)",
                                                                    border: "none",
                                                                    outline: "none",
                                                                }}
                                                                value={formData.주민등록번호}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                }
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        업종
                                                    </span>
                                                    <input
                                                        name="업종"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.업종}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        대표자명
                                                    </span>
                                                    <input
                                                        name="대표자명"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.대표자명}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        대표자연락처
                                                    </span>
                                                    <input
                                                        name="대표자연락처"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        placeholder="ex) 01012345678"
                                                        value={formData.대표자연락처}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        사업장주소
                                                    </span>
                                                    <input
                                                        name="사업장주소"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.사업장주소}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                {
                                                    formData.사업자구분 === "사업자"
                                                        ?
                                                        <div className="inner">
                                                            <span
                                                                className="left-text"
                                                                style={{ width: "120px", height: "34px" }}
                                                            >
                                                                사업자이메일
                                                            </span>
                                                            <input
                                                                name="사업자이메일"
                                                                type="text"
                                                                className="right-text"
                                                                style={{
                                                                    width: "calc(100% - 122px)",
                                                                    border: "none",
                                                                    outline: "none",
                                                                }}
                                                                value={formData.사업자이메일}
                                                                onChange={handleChange}
                                                            />
                                                        </div>
                                                        :
                                                        ""
                                                }
                                            </li>
                                        </ul>

                                        <div
                                            className="modal-header"
                                            style={{ padding: "0.5rem 0" }}
                                        >
                                            <h2 className="font-medium text-base mr-auto modal_title_sty">
                                                계약 정보
                                            </h2>
                                        </div>
                                        <ul>
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        MID
                                                    </span>
                                                    <input
                                                        name="MID"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.MID}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        영업자
                                                    </span>
                                                    <select
                                                        name="영업자"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.영업자}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">선택</option>
                                                        {levelData.map((agent, i) => {
                                                            const agentType =
                                                                agent.auth_cd === 1
                                                                    ? "지사"
                                                                    : agent.auth_cd === 2
                                                                        ? "총판"
                                                                        : "대리점";
                                                            const optionLabel = `(${agentType}) ${agent.nm}`;
                                                            return (
                                                                <option key={i} value={agent.code}>
                                                                    {optionLabel}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        통신비
                                                    </span>
                                                    <input
                                                        name="통신비"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={changeNum(Number(formData.통신비))}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        단말기대금
                                                    </span>
                                                    <input
                                                        name="단말기대금"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={changeNum(Number(formData.단말기대금))}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        1회한도
                                                    </span>
                                                    <input
                                                        name="1회한도"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={changeNum(Number(formData["1회한도"]))}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        수수료
                                                    </span>
                                                    <input
                                                        name="수수료"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={changeNum(Number(formData.수수료))}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        정산은행
                                                    </span>
                                                    <select
                                                        name="정산은행"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.정산은행}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">선택</option>
                                                        {bank.map((item, idx) => (
                                                            <option key={idx} value={item.name}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        예금주
                                                    </span>
                                                    <input
                                                        name="예금주"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.예금주}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        계좌번호
                                                    </span>
                                                    <input
                                                        name="계좌번호"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.계좌번호}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        수기노출
                                                    </span>
                                                    <select
                                                        name="수기노출"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={formData.수기노출}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="N">N</option>
                                                        <option value="Y">Y</option>
                                                    </select>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="inner">
                                                    <span className="left-text" style={{ width: "120px", height: "34px" }}>
                                                        결제방식
                                                    </span>
                                                    <div
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                            display: "flex",
                                                            gap: "10px",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <label style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                                            <input
                                                                type="checkbox"
                                                                name="결제방식"
                                                                value="단말기"
                                                                checked={formData.결제방식.includes("단말기")}
                                                                onChange={handleChange}
                                                                style={{ marginRight: "4px", width: "14px", height: "14px" }}
                                                            />
                                                            단말기
                                                        </label>
                                                        <label style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                                            <input
                                                                type="checkbox"
                                                                name="결제방식"
                                                                value="수기"
                                                                checked={formData.결제방식.includes("수기")}
                                                                onChange={handleChange}
                                                                style={{ marginRight: "4px", width: "14px", height: "14px" }}
                                                            />
                                                            수기
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="inner">
                                                    <span className="left-text" style={{ width: "120px", height: "34px" }}>
                                                        정산주기
                                                    </span>
                                                    <div
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                            display: "flex",
                                                            gap: "10px",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <label style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                                            <input
                                                                type="checkbox"
                                                                name="정산주기"
                                                                value="익일"
                                                                checked={formData.정산주기.includes("익일")}
                                                                onChange={handleChange}
                                                                style={{ marginRight: "4px", width: "14px", height: "14px" }}
                                                            />
                                                            익일
                                                        </label>
                                                        <label style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
                                                            <input
                                                                type="checkbox"
                                                                name="정산주기"
                                                                value="당일"
                                                                checked={formData.정산주기.includes("당일")}
                                                                onChange={handleChange}
                                                                style={{ marginRight: "4px", width: "14px", height: "14px" }}
                                                            />
                                                            당일
                                                        </label>
                                                    </div>
                                                </div>
                                            </li>
                                            {/* 
                                                필요하다면 지사/총판/대리점 정보 추가하는 곳.
                                                현재는 주석 처리 
                                            */}
                                            <li>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        일한도
                                                    </span>
                                                    <input
                                                        name="일한도"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={changeNum(Number(formData.일한도))}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="inner">
                                                    <span
                                                        className="left-text"
                                                        style={{ width: "120px", height: "34px" }}
                                                    >
                                                        월한도
                                                    </span>
                                                    <input
                                                        name="월한도"
                                                        type="text"
                                                        className="right-text"
                                                        style={{
                                                            width: "calc(100% - 122px)",
                                                            border: "none",
                                                            outline: "none",
                                                        }}
                                                        value={changeNum(Number(formData.월한도))}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </li>
                                            <li>
                                                <span
                                                    className="left-text"
                                                    style={{ width: "120px", height: "34px" }}
                                                >
                                                    계약서URL
                                                </span>
                                                <input
                                                    name="계약서URL"
                                                    type="text"
                                                    className="right-text"
                                                    style={{
                                                        width: "calc(100% - 122px)",
                                                        border: "none",
                                                        outline: "none",
                                                    }}
                                                    value={formData.계약서URL}
                                                    onChange={handleChange}
                                                    disabled
                                                />
                                            </li>
                                            <li>
                                                <span
                                                    className="left-text"
                                                    style={{
                                                        width: "120px",
                                                        height: `${checkboxHeight}px`,
                                                        display: "flex",
                                                        lineHeight: "26px",
                                                        justifyContent: "space-between",
                                                        alignItems: "flex-start"
                                                    }}
                                                >
                                                    불가카드
                                                    <div
                                                        style={{
                                                            marginLeft: "10px",
                                                            background: "#ddd",
                                                            border: "1px solid #aaa",
                                                            cursor: "pointer",
                                                            borderRadius: "4px",
                                                            paddingTop: "2px",
                                                            width: "22px",
                                                            height: "22px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            marginTop: "1px"
                                                        }}
                                                        onClick={() => setShowBannedCards((p) => !p)}
                                                    >
                                                        {showBannedCards ? "▲" : "▼"}
                                                    </div>
                                                </span>
                                                {showBannedCards && (
                                                    <div
                                                        className="flex flex-wrap gap-1"
                                                        style={{ fontSize: "0.7rem", padding: "5px", width: "calc(100% - 120px)" }}
                                                        ref={refCheckboxHeight}
                                                    >
                                                        {불가카드옵션.map((card) => (
                                                            <label
                                                                key={card}
                                                                className="flex items-center gap-1 cursor-pointer"
                                                                style={{ width: "100px" }}
                                                            >
                                                                <input
                                                                    type="checkbox"
                                                                    name="불가카드"
                                                                    value={card}
                                                                    checked={formData.불가카드.includes(card)}
                                                                    onChange={handleChange}
                                                                    style={{
                                                                        width: "14px",
                                                                        height: "14px",
                                                                        border: "1px solid #646464",
                                                                    }}
                                                                />
                                                                {card}
                                                            </label>
                                                        ))}
                                                    </div>
                                                )}
                                            </li>
                                        </ul>

                                        <div
                                            className="modal-header"
                                            style={{ padding: "0.5rem 0" }}
                                        >
                                            <h2 className="font-medium text-base mr-auto modal_title_sty">
                                                업로드 정보
                                            </h2>
                                        </div>
                                        <ul>
                                            <li style={{ display: "flex" }}>
                                                <UploadListItem
                                                    label="사업자등록증"
                                                    fieldName="사업자등록증"
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                    handlePreviewClick={(previewURL) => setPreviewImage(previewURL)}
                                                    listWidth={"50%"}
                                                />
                                                <UploadListItem
                                                    label="통장사본"
                                                    fieldName="통장사본"
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                    handlePreviewClick={(previewURL) => setPreviewImage(previewURL)}
                                                    listWidth={"50%"}
                                                />
                                            </li>
                                            <li style={{ display: "flex" }}>
                                                <UploadListItem
                                                    label="신분증 앞면"
                                                    fieldName="신분증앞면"
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                    handlePreviewClick={(previewURL) => setPreviewImage(previewURL)}
                                                    listWidth={"50%"}
                                                />
                                                <UploadListItem
                                                    label="신분증 뒷면"
                                                    fieldName="신분증뒷면"
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                    handlePreviewClick={(previewURL) => setPreviewImage(previewURL)}
                                                    listWidth={"50%"}
                                                />
                                            </li>
                                            <li style={{ display: "flex" }}>
                                                <UploadListItem
                                                    label="사업장 사진"
                                                    fieldName="사업장사진"
                                                    formData={formData}
                                                    setFormData={setFormData}
                                                    handlePreviewClick={(previewURL) => setPreviewImage(previewURL)}
                                                    listWidth={"100%"}
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className="modal-footer"
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                // justifyContent: "space-between",
                                paddingRight: "0",
                                paddingLeft: "0",
                            }}
                        >
                            {/* <div style={{ display: "flex", gap: "10px" }}>
                                <button
                                    type="submit"
                                    className="btn btn-primary reg_btn"
                                    onClick={onSubmitURL}
                                    disabled={isSubmitting}
                                >
                                    계약서 발송
                                </button>
                            </div> */}
                            <div style={{ display: "flex", gap: "10px" }}>
                                <button
                                    type="submit"
                                    className="btn btn-primary w-20 reg_btn"
                                    onClick={onSubmit}
                                    disabled={isSubmitting}
                                >
                                    등록
                                </button>
                                <input
                                    type="button"
                                    className="btn btn-primary w-20 close_btn"
                                    onClick={handleCancel}
                                    style={{ backgroundColor: "darkred", border: "none" }}
                                    value="취소"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

function UploadListItem({
    label,
    fieldName,
    formData,
    setFormData,
    handlePreviewClick,
    listWidth
}) {
    const containerRef = useRef(null);
    const inputRef = useRef(null);

    const [containerHeight, setContainerHeight] = useState(0);

    // "사업장사진"이면 다중 업로드, 아니면 단일 업로드
    const isMultiple = fieldName === "사업장사진";

    // 파일 업로드
    const handleFileUpload = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        setFormData((prev) => {
            let updatedList = [...(prev[fieldName] || [])];

            if (isMultiple) {
                // 다중 업로드
                files.forEach((file) => {
                    const previewURL = URL.createObjectURL(file);
                    updatedList.push({ file, previewURL });
                });
            } else {
                // 단일 업로드
                updatedList = [];
                const [file] = files;
                const previewURL = URL.createObjectURL(file);
                updatedList.push({ file, previewURL });
            }

            return {
                ...prev,
                [fieldName]: updatedList,
            };
        });
    };

    // 개별 삭제
    const handleDeleteImage = (idx) => {
        setFormData((prev) => {
            const updatedList = [...(prev[fieldName] || [])];
            updatedList.splice(idx, 1);
            return { ...prev, [fieldName]: updatedList };
        });
    };

    // 레이아웃 변화 감지
    useLayoutEffect(() => {
        if (containerRef.current) {
            setContainerHeight(containerRef.current.clientHeight);
        }
        const arr = formData[fieldName] || [];
        if (arr.length === 0 && inputRef.current) {
            inputRef.current.value = "";
        }
    }, [formData[fieldName], fieldName]);

    return (
        <div
            style={{
                display: "flex",
                alignItems: "flex-start",
                width: listWidth, // 한 줄에 2개(50%씩)
            }}
        >
            {/* 왼쪽 라벨 */}
            <span
                className="left-text"
                style={{
                    width: "120px",
                    minHeight: containerHeight ? `${containerHeight}px` : "auto",
                    display: "inline-block",
                }}
            >
                {label}
            </span>

            {/* 우측 업로드 영역 */}
            <div ref={containerRef} style={{ flex: 1 }}>
                <input
                    type="file"
                    accept="image/*"
                    ref={inputRef}
                    multiple={isMultiple}
                    style={{
                        width: "calc(100% - 8px)",
                        border: "none",
                        outline: "none",
                        marginTop: "2px",
                        marginLeft: "6px",
                    }}
                    onChange={handleFileUpload}
                />

                {/* 썸네일 목록 */}
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                    {(formData[fieldName] || []).map((item, idx) => (
                        <div
                            key={idx}
                            style={{
                                width: "50px",
                                height: "50px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                position: "relative",
                                overflow: "hidden",
                                cursor: "pointer",
                                marginLeft: "6px",
                                marginTop: "6px",
                                marginBottom: "2px",
                            }}
                        >
                            <img
                                src={item.previewURL}
                                alt="preview"
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                onClick={() => handlePreviewClick(item.previewURL)}
                            />
                            <button
                                type="button"
                                onClick={() => handleDeleteImage(idx)}
                                style={{
                                    position: "absolute",
                                    top: "2px",
                                    right: "2px",
                                    background: "rgba(0,0,0,0.5)",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "2px",
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    padding: "2px 4px",
                                }}
                            >
                                x
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default CreateMerchants;